import { useWindowEvent } from "@mantine/hooks"
import { useState } from "react"

const useCmdClick = () => {
  const [isModifierPressed, setIsModifierPressed] = useState(false)

  useWindowEvent("keydown", (e: KeyboardEvent) => {
    if (e.metaKey || e.ctrlKey) {
      setIsModifierPressed(true)
    }
  })

  useWindowEvent("keyup", () => {
    setIsModifierPressed(false)
  })

  return isModifierPressed
}

export default useCmdClick
